const graphicStandBasePath = '/stands';

const GraphicStandConst = {
   basePath: graphicStandBasePath
};

export const FILTER_FIELDS = {
    EXHIBITOR: 'EXHIBITOR',
    HALL_NAME: 'HALL_NAME',
    BLOCK: 'BLOCK',
    STAND_NUMBER: 'STAND_NUMBER',
    SHELF_NUMBER: 'SHELF_NUMBER',
    STATUS: 'STATUS',
    COMPLETE_AT: 'COMPLETE_AT',
    EXHIBITION_EVENT: 'EXHIBITION_EVENT'
};

export const DEFAULT_FILTER_FIELDS = [
    FILTER_FIELDS.EXHIBITOR,
    FILTER_FIELDS.EXHIBITION_EVENT,
    FILTER_FIELDS.HALL_NAME,
    FILTER_FIELDS.BLOCK,
    FILTER_FIELDS.STAND_NUMBER,
    FILTER_FIELDS.STATUS,
    FILTER_FIELDS.COMPLETE_AT
];

export const GRAPHIC_STAND_STATUS = {
    OPEN: 'open',
    // COLLECTED: 'collected',
    DONE: 'done'
};

export const STORAGE_KEYS = {
    SEARCH_TEXT: 'graphicStand-search-text',
    FILTERS: 'graphicStand-filters'
};

export default GraphicStandConst;
